module.exports = __webpack_public_path__ + "static/img/bg45.ce133d44.png";